import { Deserializable } from '../deserializable';

export class AffordabilityResultsDto implements Deserializable {
  public NoOfApplicants: number;
  public GrossAnnualIncomeApp1: number;
  public OtherIncomeApp1: number;
  public GrossAnnualIncomeApp2: number;
  public OtherIncomeApp2: number;
  public MonthlyCommittedOutgoing: number;
  public MonthlyOtherOutgoing: number;
  public NoOfAdults: number;
  public NoOfChildren: number;
  public MortgageTermYrs: number;
  public MortgageTermMths: number;
  public RepaymentLoanAmount: number;
  public InterestOnlyLoanAmount: number;
  public AffordabilityResultCode: string;
  public IncomeSurplus: number;
  public MajorMinorException: string;
  public MaxBorrowingAffordability: number;
  public MaxBorrowingIncomeMultiple: number;
  public MonthlyMortgagagePaymentInterestOnly: number;
  public MonthlyMortgagagePaymentRepayment: number;
  public NetIncomePercentage: number;
  public ShortfallExceptionPercentage: number;
  public IsSuitabilityReport: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
